import React, { PureComponent } from 'react';
import {
    View,
    Text,
    Platform
} from 'react-native-web';
import { Bounce } from 'react-native-animated-spinkit';
import PropTypes from 'prop-types';
import * as Animatable from 'react-native-animatable';
import Lottie from 'react-lottie';

// Assets
import * as LoadingLottie from '../lotties/truckster_red.json';

// Configs
import GLOBAL from '../configs/config_global';

export default class LoadingView extends PureComponent {
    static propTypes = {
        isAbsolute: PropTypes.bool,
        circleSize: PropTypes.number,
        description: PropTypes.string,
        style: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        useRunningTruck: PropTypes.bool,
        customLottie: PropTypes.any,
        customTextStyle: PropTypes.object,
        isLoading: PropTypes.bool,
        renderExtraComp: PropTypes.func
    };

    static defaultProps = {
        isAbsolute: false,
        circleSize: 40,
        description: '',
        style: {},
        useRunningTruck: false,
        customTextStyle: {},
        isLoading: true,
        renderExtraComp: () => <View/>
    };

    render() {
        const {
            isAbsolute,
            circleSize,
            description,
            style,
            useRunningTruck,
            customLottie,
            customTextStyle,
            isLoading,
            renderExtraComp
        } = this.props;

        return(
            <Animatable.View
                pointerEvents={isLoading ? 'auto' : 'none'}
                animation={isLoading ? 'fadeIn' : 'fadeOut'}
                style={[
                    { alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255, 255, 255, 0.9)' },
                    isAbsolute ?
                        {
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                        :
                        { flex: 1 },
                    style
                ]}>
                {/* Loading Indicator */}
                {
                    useRunningTruck ?
                        <Lottie
                            options={{
                                loop: true,
                                autoplay: true,
                                animationData: LoadingLottie,
                                rendererSettings: {
                                    preserveAspectRatio: 'xMidYMid slice'
                                }
                            }}
                            height={customLottie?.style?.height || 120}
                            width={customLottie?.style?.width || 120}
                            isStopped={false}
                        />
                        :
                        <Bounce size={circleSize} color={GLOBAL.COLOR.MAIN}/>
                }

                {/* Description */}
                {
                    description?.trim() ?
                        <Text style={Object.assign({ textAlign: 'center', marginTop: this.props.useRunningTruck ? 0 : 16, marginHorizontal: 48, fontSize: 14, color: GLOBAL.COLOR.BASIC.BLACK_TWO, fontWeight: '500', lineHeight: 22 }, customTextStyle)}>
                            {description}
                        </Text>
                        :
                        false
                }

                {/* Extra Component */}
                {!!renderExtraComp && renderExtraComp()}
            </Animatable.View>
        );
    }
}
